import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import { FuncionarioAprovacaoDropDown } from "../../../../domain/models/funcionario_aprovacao";

import FormContainer from "../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { DefaultFormMoneyInput } from "../../../../../../common/components/default_form_money_input";
import { CadastroAprovadorForm, CadastroAprovadorSchema, defaultCadastroAprovadorForm } from "../../../schemas/CadastroAprovadores_lista/cadastro_aprovador";
import { zodResolver } from "@hookform/resolvers/zod";
import { FuncionarioAprovador } from "../../../../domain/models/funcionario_aprovador";

/**
 * AprovadorModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  funcionariosAprovacaoDropdown: FuncionarioAprovacaoDropDown[];
  aprovadorEmEdicao?: FuncionarioAprovador;
  onClose: () => void;
  onSubmit: (form: CadastroAprovadorForm) => void;
};

export const AprovadorModal = ({
  open,
  saving,
  loading,
  funcionariosAprovacaoDropdown,
  aprovadorEmEdicao,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<CadastroAprovadorForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    defaultValues: defaultCadastroAprovadorForm,
    resolver: zodResolver(CadastroAprovadorSchema),
  });

  useEffect(() => {
    if (open) hookForm.reset(aprovadorEmEdicao ? {
      idFuncionario: aprovadorEmEdicao.idFuncionario,
      email: aprovadorEmEdicao.emailFuncionario ?? '',
      valorMaximo: aprovadorEmEdicao.valorMaximo ?? null,
    } : defaultCadastroAprovadorForm);
  }, [open, hookForm, aprovadorEmEdicao]);

  const funcionariosOptions = aprovadorEmEdicao ? [{
    idFuncionario: aprovadorEmEdicao.idFuncionario,
    nomeFuncionario: aprovadorEmEdicao.nomeFuncionario,
    emailFuncionario: aprovadorEmEdicao.emailFuncionario,
    canBeSelected: true,
  }] : funcionariosAprovacaoDropdown;

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title={aprovadorEmEdicao ? "Editar Aprovador" : "Cadastrar Aprovador"}
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title="Informações" arrangement="fullRow">
        <>
          <DefaultFormAutocomplete
            name="idFuncionario"
            label="Funcionário"
            required={true}
            readOnly={saving || !!aprovadorEmEdicao}
            options={funcionariosOptions}
            getOptionKey={f => f.idFuncionario}
            getOptionLabel={f => f.nomeFuncionario}
            reactHookForm={hookForm}
            onChangeValue={e => {
              const item = funcionariosAprovacaoDropdown.find(x => x.idFuncionario === Number(e));
              if (item) {
                hookForm.setValue('email', item.emailFuncionario);
              }
            }}
          />

          <DefaultFormInput
            name="email"
            label="E-mail"
            required={true}
            readOnly={saving}
            autoComplete="email"
            reactHookForm={hookForm}
          />

          <DefaultFormMoneyInput
            name='valorMaximo'
            label='Valor Máximo'
            reactHookForm={hookForm}
          />
        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
};
